module.exports = __webpack_public_path__ + "iconfont.eot?dec562c54fd65441e9f83c9298d4b6de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.eot?t=1612683013658
// module id = 3
// module chunks = 0